export interface GraphNode {
  id: string
  type: 'exception_type' | 'resolution_pattern' | 'xbrl_concept' |
        'reference_document' | 'control_objective' | 'failure_pattern' | 'detection_rule'
  label: string
  metadata: Record<string, any>
}

export interface GraphEdge {
  source: string
  target: string
  relationship: string
  metadata?: Record<string, any>
}

export interface GraphResponse {
  nodes: GraphNode[]
  edges: GraphEdge[]
  stats: {
    total_nodes: number
    total_edges: number
    by_type: Record<string, number>
    by_relationship: Record<string, number>
  }
}

export interface GraphFilters {
  framework: 'US_GAAP' | 'IFRS' | 'ALL'
  nodeTypes: Set<string>
  searchQuery: string
}

export const ALL_NODE_TYPES = [
  'exception_type', 'resolution_pattern', 'xbrl_concept',
  'reference_document', 'control_objective', 'failure_pattern', 'detection_rule',
] as const

export const NODE_TYPE_LABELS: Record<string, string> = {
  exception_type: 'Exception Types',
  resolution_pattern: 'Patterns',
  xbrl_concept: 'XBRL',
  reference_document: 'Standards',
  control_objective: 'Controls',
  failure_pattern: 'Failures',
  detection_rule: 'Rules',
}
